
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.985 18.925c1.3-1.2 2.5-2.5 3.8-3.8l2.9-2.9c.2-.1.7-.5 1-.9.2.4.8.8 1 1l2.6 2.6 4 4c.9.9 1.3-2.1.7-2.7l-8-8c-.3-.3-.4-.3-.7 0l-8 8c-.6.6-.2 3.7.7 2.7z"}})])
          )
        }
      }
    